"use strict";

$(document).ready(function () {
  lang_dropdown();
  mobileBurger();
  mobileMega();
  console.log('qwer');
  $('.search-trigger').click(function () {
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
      $('.mobile-search-block').removeClass('open');
    } else {
      $(this).addClass('active');
      $('.mobile-search-block').addClass('open');
    }
  });
  $(document).on('click', 'body.overflow_hidden .overlay', function () {
    if ($('.mobile-header-wrapper').hasClass('active')) {
      $('.mobile-header-wrapper').removeClass('active');
      $('body').removeClass('overflow_hidden');
    }
  });
  $(document).on('click', '.arrow-for-sub', function (e) {
    var thisEl = $(this);
    var thisLi = thisEl.parents('li');
    var thisSub = thisLi.find('.adtm_sub');
    e.preventDefault();
    e.stopPropagation();

    if (thisSub.hasClass('adtm_sub_open')) {
      $('.mobile-header-wrapper').removeClass('opened_sub');
      thisSub.removeClass('adtm_sub_open');
    } else {
      $('.mobile-header-wrapper').addClass('opened_sub');
      thisSub.addClass('adtm_sub_open');
    }
  });
  $(document).on('click', '.advtm_menu_span', function () {
    var thisEl = $(this);
    var thisLi = thisEl.parents('li');
    var thisSub = thisLi.find('.adtm_sub');

    if ($(window).width() < 1151) {
      setTimeout(function () {
        $('.mobile-header-wrapper').removeClass('opened_sub');
        thisSub.removeClass('adtm_sub_open');
      }, 50);
    }
  });
});

function lang_dropdown() {
  var toggle = $('header .language_switch .current_language');
  toggle.on('click', function () {
    if (toggle.next('ul').hasClass('active')) {
      toggle.next('ul').removeClass('active');
    } else {
      toggle.next('ul').addClass('active');
    }
  });
}

function mobileBurger() {
  var toggle = $('header .mobile-header-wrapper .left-side .burger');
  var closetoggle = $('header .mobile-header-wrapper .side_heading .burger_close');
  var container = $('header .mobile-header-wrapper');
  toggle.on('click', function () {
    if (toggle.hasClass('active')) {
      toggle.removeClass('active');
      container.removeClass('active');
      $('body').removeClass('overflow_hidden');
    } else {
      toggle.addClass('active');
      container.addClass('active');
      $('body').addClass('overflow_hidden');
    }
  });
  closetoggle.on('click', function () {
    if (container.hasClass('active')) {
      toggle.removeClass('active');
      container.removeClass('active');
      $('body').removeClass('overflow_hidden');
    } else {
      toggle.addClass('active');
      container.addClass('active');
      $('body').addClass('overflow_hidden');
    }
  });
}

function mobileMega() {
  $('header .mobile-header-wrapper .side_heading .adtm_menu_container .adtm_menu .adtm_menu_inner ul li.sub a').on('click', function (e) {
    // e.preventDefault();
    var headercontainer = $('header .mobile-header-wrapper');
    var dropdown = $(this).next('div.adtm_sub');
    headercontainer.addClass('opened-sub');
    dropdown.addClass('opened-sub');
    $(this).parents('.adtm_menu_inner').addClass('advtm_open_on_hover');
  });
  $('header .mobile-header-wrapper .side_heading .adtm_menu_container .adtm_menu .adtm_menu_inner ul li.sub .adtm_sub .go_back').on('click', function (e) {
    $(this).parents('.adtm_sub').removeClass('opened-sub');
    $('.adtm_menu > div.adtm_menu_inner').removeClass('advtm_open_on_hover');
    $('.mobile-header-wrapper').removeClass('opened-sub');
  });
}